import { FC } from "react";

import { FormType, TicketingFormCategory } from "@simplyk/common";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { parseAddress } from "@/canvas/features/FormV2/helpers/parseAddress";
import { useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { FORM_ELEMENT_IDS } from "@/features/LiveFormEditor/Steps/helpers/formStepToElementIdMap";
import { FormLocation, FormLocationProps } from "@/forms-design-system/FormLocation";

type CampaignLocationProps = Omit<FormLocationProps, "title" | "subtitle">;

export const CampaignLocation: FC<CampaignLocationProps> = ({ sx, ...rest }) => {
  const { t } = useTranslate();
  const { formObject, hasLocation, formCategory } = useFormV2Context(FormType.Ticketing);
  const isLocationGhostPreview = useIsGhostPreview("TicketingV2AddressSummary");

  if (!hasLocation) {
    return null;
  }

  const { street, cityStateZip } = parseAddress(formObject.address!);
  const isShop = formCategory === TicketingFormCategory.Shop;
  const locationLabel = isShop ? t("ticketing", "fulfillment.pickupAt") : undefined;
  const googleMapsLink =
    formObject.coordinates?.latitude && formObject.coordinates?.longitude
      ? `https://www.google.com/maps?q=${formObject.coordinates.latitude},${formObject.coordinates.longitude}`
      : undefined;
  const fullAddress = [street, cityStateZip].filter(Boolean).join(", ");
  const opacity = isLocationGhostPreview ? GHOST_PREVIEW_OPACITY : 1;

  return (
    <FormLocation
      title={locationLabel ?? street}
      subtitle={locationLabel ? fullAddress : cityStateZip}
      href={googleMapsLink}
      target="_blank"
      rel="noopener noreferrer"
      id={FORM_ELEMENT_IDS["location"]}
      sx={{ opacity, ...sx }}
      {...rest}
    />
  );
};
